"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _Fonts = require("../../00_environment/Fonts");

var _Page = _interopRequireDefault(require("../../01_atoms/Page"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Step = function Step(_ref) {
  var picture = _ref.picture,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? '' : _ref$footer,
      t = _ref.translator;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '80vh'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: picture,
    style: {
      height: '30vh'
    },
    verticalAlign: "middle"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDefaultFont)({
      marginTop: 30,
      textAlign: 'center',
      maxWidth: 'min(350px, 80vw)'
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      marginBottom: 20
    }
  }, t(title.trim())), t(text.trim()), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      marginTop: 20
    }
  }, t(footer.trim()))));
};

var BetaOnboardingCarousselPageUI = function BetaOnboardingCarousselPageUI(_ref2) {
  var _ref2$selectedStep = _ref2.selectedStep,
      selectedStep = _ref2$selectedStep === void 0 ? 0 : _ref2$selectedStep,
      _ref2$steps = _ref2.steps,
      steps = _ref2$steps === void 0 ? [] : _ref2$steps,
      _ref2$prevButtonDisab = _ref2.prevButtonDisabled,
      prevButtonDisabled = _ref2$prevButtonDisab === void 0 ? false : _ref2$prevButtonDisab,
      _ref2$nextButtonLabel = _ref2.nextButtonLabel,
      nextButtonLabel = _ref2$nextButtonLabel === void 0 ? 'Next' : _ref2$nextButtonLabel,
      _ref2$onPrev = _ref2.onPrev,
      onPrev = _ref2$onPrev === void 0 ? function () {} : _ref2$onPrev,
      _ref2$onNext = _ref2.onNext,
      onNext = _ref2$onNext === void 0 ? function () {} : _ref2$onNext,
      translatorForNamespace = _ref2.translatorForNamespace;
  var t = translatorForNamespace('BetaOnboardingCarousselPageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
    index: selectedStep,
    enableMouseEvents: true,
    onChangeIndex: function onChangeIndex(index, indexLatest) {
      if (indexLatest < index) {
        onNext();
      } else {
        onPrev();
      }
    }
  }, steps.map(function (st) {
    return /*#__PURE__*/_react["default"].createElement(Step, _extends({
      key: st.text
    }, st, {
      translator: t
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: '5%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withDiscreetLinkButtonFont)({
      textDecoration: 'none',
      cursor: 'pointer',
      visibility: prevButtonDisabled ? 'hidden' : 'visible'
    }),
    onClick: function onClick() {
      if (prevButtonDisabled) {
        return;
      } // reactSwipeEl.prev();


      onPrev();
    }
  }, t('Previous')), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withLinkButtonFont)({
      textDecoration: 'none',
      cursor: 'pointer'
    }),
    onClick: function onClick() {
      // reactSwipeEl.next();
      onNext();
    }
  }, t(nextButtonLabel)))));
};

var _default = BetaOnboardingCarousselPageUI;
exports["default"] = _default;